import { isServer } from './environment';

// Cache the value since the device doesn't change during the app life cycle to improve performance
let isMobileDevice: boolean | undefined;

/**
 * @returns `true` if the user agent string is indicative of a mobile device; otherwise, `false`
 */
export function getIsMobileDevice(): boolean | undefined {
  if (isServer()) {
    return isMobileDevice;
  }

  if (isMobileDevice === undefined) {
    const userAgentRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    isMobileDevice = userAgentRegex.test(navigator.userAgent);
  }

  return isMobileDevice;
}
